import { jsx as m } from "react/jsx-runtime";
import { Children as n } from "react";
import { f as h } from "../../../index-CZ8zjHGv.js";
import { makeDimensionNegative as f } from "../../../styles/dimensions/dimensions.js";
import e from "../Box/Box.js";
import "styled-components";
function C({
  children: i,
  space: r,
  justifyContent: p = "flex-start",
  alignItems: a,
  flexWrap: d = "wrap",
  flexValues: o
}) {
  if (o && o.length !== n.count(i))
    throw new Error("You must provide a flex value for each child");
  return /* @__PURE__ */ m(
    e,
    {
      marginLeft: f(r),
      marginTop: f(r),
      display: "flex",
      justifyContent: p,
      flexWrap: d,
      alignItems: a,
      children: n.map(h(i), (l, t) => /* @__PURE__ */ m(
        e,
        {
          paddingLeft: r,
          paddingTop: r,
          flex: o ? o[t] : void 0,
          children: l
        },
        t
      ))
    }
  );
}
export {
  C as default
};
